import { Formik, type FormikConfig } from 'formik'

import type { BidFormFormikValues } from '@/buyer-portal/components/features/listing/actions/auction/BidFormProvider'
import { useBidAmountSchema } from '@/buyer-portal/components/features/listing/actions/auction/useBidAmountSchema'
import { useActivePhase } from '@/buyer-portal/helpers/auctions/buyingFormat'
import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import { AuctionActionCellContent } from './AuctionActionCellContent'
import { getBidFormId } from './getBidFormId'
import { getMinBidAmount } from './getMinBidAmount'

export const AuctionActionCellPreload = ({
  onClickBuyNow,
  onSubmit,
  searchListing,
}: {
  onClickBuyNow: () => void
  onSubmit: FormikConfig<BidFormFormikValues>['onSubmit']
  searchListing: CombinedListingSearchResult
}) => {
  const { bidBasis, bidPrecision, currency } = searchListing

  const activePhase = useActivePhase(searchListing.originalSearchResult)
  const userMinBidAmount = getMinBidAmount(searchListing, activePhase)

  const validationSchema = useBidAmountSchema({
    bidPrecision,
    currency,
    isRelativeBid: bidBasis === 'RELATIVE',
    userMinBidAmount,
  })

  const initialValues: BidFormFormikValues = { amount: '' }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ handleSubmit }) => (
        <form
          id={getBidFormId(searchListing.listingId)}
          onSubmit={handleSubmit}
        >
          <AuctionActionCellContent
            activePhase={activePhase}
            onClickBuyNow={onClickBuyNow}
            searchListing={searchListing}
          />
        </form>
      )}
    </Formik>
  )
}
